import { render, staticRenderFns } from "./WebinarAnnouncementModal.vue?vue&type=template&id=4560bebb&scoped=true"
import script from "./WebinarAnnouncementModal.vue?vue&type=script&lang=ts"
export * from "./WebinarAnnouncementModal.vue?vue&type=script&lang=ts"
import style0 from "./WebinarAnnouncementModal.vue?vue&type=style&index=0&id=4560bebb&prod&lang=sass&scoped=true"
import style1 from "./WebinarAnnouncementModal.vue?vue&type=style&index=1&id=4560bebb&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4560bebb",
  null
  
)

export default component.exports